export const UserPanelWidth = 320
export const UserPanelWidthMd = 290
